/** @format */
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { LocalizedString, OtmId, Plan } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { MyPlanSelectComponentService, PlanSelectOption } from './my-plan-select-component.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'app-my-plan-select',
    templateUrl: './my-plan-select.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MyPlanSelectComponentService],
})
export class MyPlanSelectComponent {
    static readonly downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.common.components.myPlanSelect.downgraded',
        directiveName: 'appMyPlanSelect',
    };

    constructor(private readonly _myService: MyPlanSelectComponentService) {}

    get selectedPlan$(): Observable<Plan | null> {
        return this._myService.selectedPlan$;
    }

    get selectedLearningOpportunityName$(): Observable<LocalizedString | null | undefined> {
        return this._myService.selectedLearningOpportunityName$;
    }

    get options$(): Observable<readonly PlanSelectOption[]> {
        return this._myService.options$;
    }

    get selectedPlanEducationName$(): Observable<LocalizedString | null> {
        return this._myService.selectedPlanEducationName$;
    }

    get selectedPlanCurriculumPeriodName$(): Observable<LocalizedString | null> {
        return this._myService.selectedPlanCurriculumPeriodName$;
    }

    onSelect(planId: OtmId): void {
        this._myService.onSelect(planId);
    }
}
